import "./styles.css";

import CTAForm from "../../components/CTAForm";

import content1 from "../../assets/mobile/content1.png";
import image1 from "../../assets/1.png";
import image2 from "../../assets/2.png";
import image3 from "../../assets/3.png";
import content2_1 from "../../assets/content2_1.png";
import content2_2 from "../../assets/content2_2.png";
import content2_3 from "../../assets/content2_3.png";
import content3 from "../../assets/content3.png";
import content3Mobile from "../../assets/mobile/content3.png";

const Content = () => {
  const isMobile =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );

  return (
    <section id="content">
      <article className="content1">
        <div className="container vertical">
          <h1 className="title">
            Anotação Avançada de Imagens para uma <span>Comunicação Clara</span>
          </h1>

          <p className="text">
            Os poderosos recursos de edição de imagem do SAV permitem que o
            Técnico de Segurança do Trabalho:
          </p>

          <div className="gallery">
            <div className="left"></div>

            <div className="right">
              <div className="items">
                <div className="item">
                  <figure>
                    <img src={image1} alt="1" />
                  </figure>

                  <p className="text">
                    Aprimore a documentação de perigos diretamente no campo;
                  </p>
                </div>

                <div className="item">
                  <figure>
                    <img src={image2} alt="2" />
                  </figure>

                  <p className="text">Destaque áreas de risco específicas;</p>
                </div>

                <div className="item">
                  <figure>
                    <img src={image3} alt="3" />
                  </figure>

                  <p className="text">
                    Adicione descrições de texto e chame a atenção para
                    preocupações críticas de segurança.
                  </p>
                </div>
              </div>

              <figure className="mobile">
                <img src={content1} alt="Ícone de Celular" />
              </figure>

              <p className="text">
                Essa abordagem de comunicação visual garante que as partes
                interessadas, em todos os níveis, compreendam, imediatamente, a
                gravidade e a natureza dos problemas identificados, executando a
                resolução rapidamente.
              </p>

              <CTAForm />
            </div>
          </div>
        </div>
      </article>

      <article className="content2">
        <div className="container vertical">
          <h2 className="title">
            Sugestões de melhoria com <br />
            <span>tecnologia de IA</span>
          </h2>

          <div className="gallery">
            <div className="item">
              <figure>
                <img src={content2_1} alt="Ícone" />
              </figure>

              <p className="item_title">Análise Inteligente de Perigos</p>

              <p className="item_text">
                O mecanismo de inteligência artificial do SAV analisa os
                problemas de segurança detectados e fornece recomendações
                específicas do contexto com base nas melhores práticas do setor
                e nos requisitos normativos.
              </p>
            </div>

            <div className="item">
              <figure>
                <img src={content2_2} alt="Ícone" />
              </figure>

              <p className="item_title">Planejamento de Ações Preventivas</p>

              <p className="item_text">
                Receba sugestões de melhoria personalizadas que ajudarão a
                evitar acidentes antes de que ocorram. A IA aprende
                continuamente com os padrões específicos do seu local de
                trabalho para fornecer orientações cada vez mais relevantes.
              </p>
            </div>

            <div className="item">
              <figure>
                <img src={content2_3} alt="Ícone" />
              </figure>

              <p className="item_title">Análise Inteligente de Perigos</p>

              <p className="item_text">
                Implemente soluções recomendadas por IA para garantir que seu
                local de trabalho atenda ou exceda todos os padrões de segurança
                aplicáveis, reduzindo a responsabilidade e protegendo sua força
                de trabalho.
              </p>
            </div>
          </div>

          <CTAForm />
        </div>
      </article>

      <article className="content3">
        <div className="container">
          <figure>
            <img src={isMobile ? content3Mobile : content3} alt="Imagem" />
          </figure>
        </div>
      </article>
    </section>
  );
};

export default Content;
